import { useEffect } from "react";
import AIAssistant from "@/components/ai-assistant/AIAssistant";

const ObraIA = () => {
  useEffect(() => {
    document.title = "Obra IA";
  }, []);

  // A navegação fica na sidebar do app; aqui só ocupamos a altura restante
  // abaixo da AuthenticatedTopBar (h-14 = 3.5rem).
  return (
    <div className="h-[calc(100dvh-3.5rem)] w-full overflow-hidden">
      <AIAssistant />
    </div>
  );
};

export default ObraIA;
